// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.schools-label {
  color: #19608f;
  font-weight: 550;
  font-size: 1.2rem;
  margin-bottom: 10px;
}
.schools-label span {
  font-weight: 700;
}

.schools-heading {
  font-weight: 600;
  font-size: 1.3rem;
  margin-bottom: 15px;
}

.schools-container {
  border-radius: 10px;
  background: #D1D3D4;
  border: 2px solid #0669B3;
  padding: 20px 30px;
}
.schools-container .schools-body {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 10px 20px;
  width: 100%;
}
.schools-container .top-text {
  font-weight: 600;
}
.schools-container span {
  font-weight: 550;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/FeederContainer.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,cDIM;ECHN,gBAAA;EACA,iBAAA;EACA,mBAAA;AAUJ;AARI;EACI,gBAAA;AAUR;;AANA;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;AASJ;;AANA;ECjBI,mBDkBsB;EACtB,mBDHI;ECIJ,yBAAA;EACA,kBAAA;AASJ;AAPI;ECvBA,mBDwB0B;ECH1B,2CAAA;EDKI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AASR;AAPI;EACI,gBAAA;AASR;AANI;EACI,gBAAA;AAQR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"./global/Colors.scss\";\n@import \"./global/globalMixins.scss\";\n\n.schools-label {\n    color: $dk-blue;\n    font-weight: 550;\n    font-size: 1.2rem;\n    margin-bottom: 10px;\n\n    span {\n        font-weight: 700;\n    }\n}\n\n.schools-heading {\n    font-weight: 600;\n    font-size: 1.3rem;\n    margin-bottom: 15px;\n}\n\n.schools-container {\n    @include borderRadius(10px);\n    background: $grey1;\n    border: 2px solid $pearl-blue;\n    padding: 20px 30px;\n\n    .schools-body {\n        @include borderRadius(10px);\n        @include shadow();\n        background: white;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center; //flex-start;\n        padding: 10px 20px;\n        width: 100%\n    }\n    .top-text {\n        font-weight: 600;\n    }\n\n    span {\n        font-weight: 550;\n    }\n}","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
